<div class="mb-myaccount-container">
  <div *ngIf="(user$ | async) as user" class="desktop-container">
    <mb-myaccount-background></mb-myaccount-background>
    <div class="row mb-5 my-account-content">
      <div *ngIf="(user$ | async) as user"  class="col-12 col-md-8">
        <div class="d-md-none">
          <mb-myaccount-logout></mb-myaccount-logout>
        </div>
        <mb-myaccount-tile
          [welcomeTile]="true"
          [text]="('mbMyAccount.welcome' | cxTranslate).toString() + user?.firstName + ' ' + user?.lastName +  '!'"
          [mobileText]="('mbMyAccount.welcomeMobile' | cxTranslate).toString() +  user?.firstName + '!'"
          [heightREM]="30"
          [backgroundImageLocation]="'assets/images/my-account/Welcome_teaser_with_text.png'"
          [textLarge]="true"
          [hover]="false"
        ></mb-myaccount-tile>
      </div>
      <div class="col-4 d-none d-md-block">
        <mb-myaccount-navigation></mb-myaccount-navigation>
      </div>
    </div>
    <div class="row mb-5 mb-myaccount-tiles">
      <div class="col-12 col-md-4 mb-3">
        <mb-myaccount-tile
          [linkText]="'mbMyAccount.universityLinkText' | cxTranslate"
          [linkUrl]="user.universityStatus ? environment.myAccount.universityUrl : muRegistrationUrl"
          [backgroundImageLocation]="'assets/images/my-account/nav_bg_university.png'"
          [externalUrl]="true"
        ></mb-myaccount-tile>
      </div>
      <div class="col-12 col-md-4 mb-3">
        <mb-myaccount-tile *ngIf="user.pickupStatus === 'is in use'"
          [linkText]="'mbMyAccount.mpupLinkText' | cxTranslate"
          [linkUrl]="'/mpup/inventory'"
          [backgroundImageLocation]="'assets/images/my-account/MPUP_dashboard_teaser.png'"
        ></mb-myaccount-tile>
      </div>
    </div>
    <div class="row mb-5 my-account-contact-box">
      <div class="col-12 col-md-7 offset-md-5 col-lg-5 offset-lg-7">
        <mb-myaccount-contactbox></mb-myaccount-contactbox>
      </div>
    </div>
    <div>
      <mb-myaccount-mobile-navigation></mb-myaccount-mobile-navigation>
    </div>
  </div>

</div>
